import React, { Component } from 'react'
import { Dropdown, Flag, Icon, Menu } from 'semantic-ui-react'
import { Mutation } from 'react-apollo'

import { MutationUpdatePreferencesFromCache } from '../graphql'

const languages = [
  { key: 'de', flag: 'de', text: 'Deutsch' },
  { key: 'en', flag: 'gb', text: 'English' }
]

class LanguageMenu extends Component {

  constructor (props) {
    super(props)
    this.state = { activeLang: null }
  }

  componentDidMount () {
    const { lang } = this.props
    this.updateLanguage(lang)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.lang !== nextProps.lang) {
      this.updateLanguage(nextProps.lang)
    }
  }

  updateLanguage = (lang) => {
    this.setState({ activeLang: languages.filter((language) => {return language.key === lang})[0] })
  }

  onHandleUpdateLanguage = (e, { lang }, mutation_updatePreferences) => {
    // Call function in parent component
    this.updateLanguage(lang)
    this.props.onChangeLanguage(lang)

    mutation_updatePreferences({variables: {
      lang: lang,
      state: null
      }
    })
  }

  render () {
    const { activeLang } = this.state
    if (!activeLang) return null

    return (
      <div>
        { activeLang ? (
          <Mutation mutation={MutationUpdatePreferencesFromCache}>
            {(updatePreferences, {error}) => {
              if (error) return `Error!: ${error}`

              return (
                <Menu.Menu item='true' position='right' className='language-menu'>
                  <Dropdown style={{padding: '1em'}}
                    trigger={(
                      <span className='dropdown-trigger'>
                          <span className='language'>{activeLang.text}</span>
                          <Icon name='world' />
                      </span>
                    )}>
                    <Dropdown.Menu>
                      { languages.map((lang, i) => (
                        <Dropdown.Item key={lang.key} active={activeLang.key === lang.key}
                          lang={lang.key} onClick={(event, data) => {
                            this.onHandleUpdateLanguage(event, data, updatePreferences)
                            }}>
                            <Flag name={lang.flag} /> {lang.text}
                        </Dropdown.Item>
                        )
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </Menu.Menu>
              )
            }}
          </Mutation>
        ) : null }
      </div>
    )
  }
}

export default LanguageMenu



// WEBPACK FOOTER //
// ./src/components/LanguageMenu.js